import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import {loader, toastr} from '../CommonActions'
import { auth, userService} from '../../../services';

export const GET_MEMBERSHIPS_SUCCESS = 'GET_MEMBERSHIPS_SUCCESS';
export const ADD_ADMIN_MEMBERSHIP = 'ADD_ADMIN_MEMBERSHIP';
export const DELETE_ADMIN_MEMBERSHIP = 'DELETE_ADMIN_MEMBERSHIP';
export const UPDATE_ADMIN_MEMBERSHIP = 'UPDATE_ADMIN_MEMBERSHIP';
export const GET_MEMBERSHIP_HISTORY = 'GET_MEMBERSHIP_HISTORY';
export const GET_MEMBERSHIP_NOTES = 'GET_MEMBERSHIP_NOTES';
export const ADD_MEMBERSHIP_NOTES = 'ADD_MEMBERSHIP_NOTES';

const successColor =  "success";
const errorColor = "danger";
const warningColor = "warning";

export function fetchAllMemberships() {
    return function (dispatch) {
		dispatch(loader(true));
		var url = `${ROOT_API_URL}/ManageMembership/GetMemberships`;
		const options = { method: 'GET', headers: auth.authHeader() };
		axios
			.get(url, options)
			.then((response) => {
				dispatch({
					type: GET_MEMBERSHIPS_SUCCESS,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((error) => {
				var err = "Network Connection Error"; 
				dispatch(loader(false));		
				dispatch(toastr(true,err, errorColor));
			});
	};
}

export function addAdminMembership(membership) {
	return function(dispatch) {
		dispatch(loader(true));
		var url = `${ROOT_API_URL}/ManageMembership/CreateAdminMembership`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url, membership, options).then(function(response) {
				if (response && response.data && response.data.issuccess) 
				{
					dispatch({
						type: ADD_ADMIN_MEMBERSHIP,
						payload: response.data.membershipList,
					});
					var success = response && response.data ? response.data.message : "Membership Created Successfully"; 
					dispatch(toastr(true,success, successColor));
				}
				else {
					var err = response && response.data ? response.data.message : "Membership Already Exists"; 
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : "Network Connection Error"; 
				dispatch(loader(false));		
				dispatch(toastr(true,err, errorColor));
			});
	};
}

export function deleteMembership(membership) {

	return function(dispatch) {
		dispatch(loader(true));
		var url = `${ROOT_API_URL}/ManageMembership/DeleteMembership`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url, membership, options).then(function(response) {
			if (response && response.data && response.data.issuccess) 
				{
					dispatch({
						type: DELETE_ADMIN_MEMBERSHIP,
					payload: response.data.membershipList
					});	
					var success = response && response.data ? response.data.message : "Membership De-activated Successfully"; 
					dispatch(toastr(true,success, successColor));
				}
				else {
					var err = response && response.data ? response.data.message : "Error Occured"; 
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				dispatch(loader(false));

				var err = response && response.data ? response.data.message : "Network Connection Error"; 
				dispatch(toastr(true,err, errorColor));
			});
	};
}

export function updateAdminMembership(membership) {
	return function(dispatch) {
		dispatch(loader(true));
		var url = `${ROOT_API_URL}/ManageMembership/UpdateAdminMembership`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url, membership, options).then(function(response) {
				console.log("update response", response)
				if (response && response.data && response.data.issuccess) 
				{
					dispatch({
						type: UPDATE_ADMIN_MEMBERSHIP,
						payload: response.data.membershipList
					});	
					var success = response && response.data ? response.data.message : "Membership Updated Successfully"; 
					dispatch(toastr(true,success, successColor));
				}
				else {
					var err = response && response.data ? response.data.message : "Error Occured"; 
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function SaveAdminMembership(membership) {
	return function (dispatch) {
		dispatch(loader(true));
		var url = `${ROOT_API_URL}/ManageMembership/SaveAdminMembership`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url, membership, options).then(function (response) {
		})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}
export function getMembershipHistory(membershipId) {
	return function(dispatch) {
		dispatch(loader(true));
		var url = `${ROOT_API_URL}/ManageMembership/GetMembershipHistory?membershipId=${membershipId}`;
		const options = { method: 'GET', headers: auth.authHeader() };
		axios
			.get(url, options)
			.then((response) => {
				dispatch({
					type: GET_MEMBERSHIP_HISTORY,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((error) => {
				var err = "Network Connection Error"; 
				dispatch(loader(false));		
				dispatch(toastr(true,err, errorColor));
			});
	};
}
export function getMembershipNotes(membershipId) {
	return function(dispatch) {
		dispatch(loader(true));
		var url = `${ROOT_API_URL}/ManageMembership/GetMembershipNotes?membershipId=${membershipId}`;
		const options = { method: 'GET', headers: auth.authHeader() };
		axios
			.get(url, options)
			.then((response) => {
				dispatch({
					type: GET_MEMBERSHIP_NOTES,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((error) => {
				var err = "Network Connection Error"; 
				dispatch(loader(false));		
				dispatch(toastr(true,err, errorColor));
			});
	};
}
export function SaveMembershipNotes(membership) {
	return function(dispatch) {
		dispatch(loader(true));
		var url = `${ROOT_API_URL}/ManageMembership/SaveMembershipNotes`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url, membership, options).then(function(response) {
				console.log("update response", response)
				if (response && response.data) 
				{
					dispatch({
						type: ADD_MEMBERSHIP_NOTES,
						payload: response.data
					});	
					var success =  "Notes Created Sucessfully" ; 
					dispatch(toastr(true,success, successColor));
				}
				else {
					var err =  "Error Occured"; 
					dispatch(toastr(true,err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}